// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FocusedNav-cls1__c9786e0eeac50293ba40{/*!*/}.FocusedNav-cls2___0f33769fb20772005dd{position:absolute;top:0;right:0;margin:0;padding:12px 16px;border:none;background:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FocusedNav-cls1__c9786e0eeac50293ba40",
	"cls2": "FocusedNav-cls2___0f33769fb20772005dd FocusedNav-cls1__c9786e0eeac50293ba40"
};
export default ___CSS_LOADER_EXPORT___;
